/**
 * @generated SignedSource<<f02c953b8fa5a110aa3ccb91d6d34e2c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "documentId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "historyEntries"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "widget"
},
v3 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "documentId",
        "variableName": "documentId"
      },
      {
        "kind": "Variable",
        "name": "historyEntries",
        "variableName": "historyEntries"
      },
      {
        "kind": "Variable",
        "name": "widget",
        "variableName": "widget"
      }
    ],
    "concreteType": "CreateOrUpdateWidgetMutation",
    "kind": "LinkedField",
    "name": "updateWidget",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "ok",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "error",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "widgetId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "UpdateWidgetMutation",
    "selections": (v3/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "UpdateWidgetMutation",
    "selections": (v3/*: any*/)
  },
  "params": {
    "cacheID": "097916763dcd050b77117f56642f86f0",
    "id": null,
    "metadata": {},
    "name": "UpdateWidgetMutation",
    "operationKind": "mutation",
    "text": "mutation UpdateWidgetMutation(\n  $widget: WidgetInput!\n  $documentId: ID\n  $historyEntries: [DocumentHistoryEntryInput!]\n) {\n  updateWidget(widget: $widget, documentId: $documentId, historyEntries: $historyEntries) {\n    ok\n    error\n    widgetId\n  }\n}\n"
  }
};
})();

node.hash = "740751fe93d3d9e7bd3b945eb09f8a6a";

export default node;
